var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestimonialsTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 56,
    viewBox: "0 0 71 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3789 27.3438V29.1992H25.9766V55.1758H0V29.3945C0 9.79818 8.65885 0 25.9766 0V10.9375C21.5495 11.6536 18.3268 13.3464 16.3086 16.0156C14.3555 18.6198 13.3789 22.3958 13.3789 27.3438ZM57.6172 27.3438V29.1992H70.2148V55.1758H44.3359V29.3945C44.3359 9.79818 52.9622 0 70.2148 0V10.9375C61.8164 12.0443 57.6172 17.513 57.6172 27.3438Z",
    fill: "#A52EB1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialsTop);
export default __webpack_public_path__ + "static/media/testimonials-top.69a0d60447bb906e77c792721c8ad732.svg";
export { ForwardRef as ReactComponent };